import { CSSProperties } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { ReceiptV2Status } from '~/models';

interface IProps {
  status: ReceiptV2Status;
}

export const ReceiptStatus = ({ status }: IProps) => {
  const getStyles = (): CSSProperties => {
    switch (status) {
      case ReceiptV2Status.Pending:
        return {
          color: colors.secondary[500],
        };
      case ReceiptV2Status.Refunded:
        return {
          color: colors.success[600],
        };
      case ReceiptV2Status.Succeeded:
        return {
          color: colors.primary[500],
        };
      default:
        return {
          color: colors.neutral[600],
        };
    }
  };

  return (
    <Typography as="span" bold size="caption_sm" style={{ ...getStyles() }} uppercase>
      {status}
    </Typography>
  );
};
